import React from 'react';

import { connect } from 'react-redux';

import { itemOccurrences } from '../../utils/itemOccurrences';
import {
  analyticsClearEcommerce,
  analyticsViewCalendarItemList,
} from '../../middlewares/analytics/actions';

import FeaturedEvent from './FeaturedEvent';

import './FeaturedEvents.sass';

@connect()
export default class FeaturedEvents extends React.PureComponent {
  getProductsFromEvents = (events) => {
    return events.map((event) => {
      const product = event[0].productVariant.product;
      const price = event[0].productVariant.price;

      return {
        ...product,
        price,
      };
    });
  };

  componentDidMount() {
    const { taxon, events, dispatch } = this.props;

    if (taxon && events) {
      const products = this.getProductsFromEvents(events);

      if (products) {
        dispatch(analyticsClearEcommerce());
        dispatch(analyticsViewCalendarItemList(taxon, products));
      }
    }
  }

  componentDidUpdate() {
    const { taxon, events, dispatch } = this.props;

    if (taxon && events) {
      const products = this.getProductsFromEvents(events);

      if (products) {
        dispatch(analyticsClearEcommerce());
        dispatch(analyticsViewCalendarItemList(taxon, products));
      }
    }
  }

  render() {
    const { events, taxon } = this.props;

    return (
      <div className="featured-events">
        {events.map((event, index) => {
          const firstEvent = event[0].productVariant;
          const occurrences = itemOccurrences(event);
          const initialOccurrence = occurrences[0];

          return (
            <FeaturedEvent
              key={firstEvent.id}
              variantId={firstEvent.id}
              occurrences={occurrences}
              initialOccurrence={initialOccurrence}
              selectedVariant={firstEvent}
              taxon={taxon}
              index={index}
            />
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/featuredEvents/FeaturedEvents.js